import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SafeHtmlPipePipe } from '../../shared/pipes/safe-html.pipe';
import { ConvertLinkablePipe } from '@app/shared/pipes/convert-linkable.pipe';

@Component({
    selector: 'app-agent-message',
    templateUrl: './agent-message.component.html',
    styleUrls: ['./agent-message.component.scss'],
    standalone: true,
    imports: [DatePipe, SafeHtmlPipePipe, ConvertLinkablePipe]
})
export class AgentMessageComponent {
  @Input() msg: any; // todo - type this out
}
